import { render, staticRenderFns } from "./CDRQSummary.vue?vue&type=template&id=4e777b5a&scoped=true&"
import script from "./CDRQSummary.vue?vue&type=script&lang=ts&"
export * from "./CDRQSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e777b5a",
  null
  
)

export default component.exports